var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail_7_",
    "data-name": "mail (7)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.739,
    height: 14.582,
    viewBox: "0 0 20.739 14.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M18.916,76H1.823A1.825,1.825,0,0,0,0,77.823V88.759a1.826,1.826,0,0,0,1.823,1.823H18.916a1.825,1.825,0,0,0,1.823-1.823V77.823A1.825,1.825,0,0,0,18.916,76Zm-.255,1.215-7,6.966a1.823,1.823,0,0,1-2.579,0l-7-6.965ZM1.215,88.512V78.071l5.251,5.223Zm.864.855,5.249-5.216.894.889a3.038,3.038,0,0,0,4.3,0l.895-.89,5.249,5.216Zm17.445-.855-5.251-5.218,5.251-5.223Z",
    transform: "translate(0 -76)",
    fill: "#cbcbcb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b13b4b46d0ca01edee6d229ec8ab71db.svg";
export { ForwardRef as ReactComponent };